import React from 'react';

type Props = {
  url?: string;
  label?: string;
  caption?: string;
};
/**
 * @description
 * A wrapper for the HTML5 audio element.
 * 'caption' is deprecated, use 'label' instead.
 */
const AudioPlayer = ({ url, label, caption }: Props) => {
  return (
    <audio controls src={url} data-testid="audio-player">
      <track kind="captions" label={label ?? caption} />
    </audio>
  );
};

export default AudioPlayer;
